import {
  ActivationStatus
} from '../enums/add-on/activation-status'
export const promotionPageMixin = {
  props: {
    promotionPage: {
      type: Object,
      default: () => null
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    sectionId: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    addOn () {
      return this.promotionPage.addOn
    },
    subscriptionPlans () {
      return this.promotionPage.addOnSubscriptionPlans || []
    },
    addOnSubscriptions () {
      return this.promotionPage.addOnSubscriptions || []
    },
    activationStatus () {
      return this.promotionPage.activationStatus
    },
    ctaUrl () {
      let activationStatus = this.activationStatus
      let url = ''
      let addOn = this.addOn
      if (addOn) {
        switch (activationStatus) {
          // To admin page (settings)
          case ActivationStatus.Subscribed:
            url = addOn.ApplicationUrl
            break
            // To activation page (wizard)
          default:
            url = addOn.ActivationUrl
            break
        }
      }
      return url
    },
    componentStyle () {
      return {
        backgroundColor: this.backgroundColor
      }
    }
  }
}
export default promotionPageMixin
